/**
 * Created by mbreighith on 9/16/18.
 */
(function () {

    "use strict";

    angular
        .module('userActivation')
        .component('hEmailVerification', {
            controller: HEmailVerificationComponent,
            controllerAs: 'hEmailVerificationComponent',
            bindings: {
                onVerified: '&',
                fromStepper: '<?'
            },
            templateUrl: '../hmodules/user-activation/components/h-email-verification/h-email-verification.component.ng.html'
        });

    HEmailVerificationComponent.$inject = ['$scope', '$q', '$timeout', 'hUser', '$alert', '$filter', '$modal'];

    function HEmailVerificationComponent($scope, $q, $timeout, hUser, $alert, $filter, $modal) {
        var self = this;

        self.$onInit = function () {
            self.loading = true;
            self.emailIsVerified = false;
            self.phoneIsVerified = false;
            self.isAutoLogin = false;
            SettingsAPI.loadPersonalInformation()
                .then(function (res) {

                    self.verification_email = res.email;
                    self.verification_phone = res.phone;
                    var isAutoLogin = res.is_auto_login || false;

                    if (isAutoLogin) {
                        self.isAutoLogin = true;
                    } else if (res.email && res.email_status !== 'VERIFIED') {
                        self.needsEmailVerification = true;
                    } else if (res.email && res.email_status === 'VERIFIED') {
                        self.emailIsVerified = true;
                        self.needsEmailVerification = false;
                        self.needsPhoneVerification = false;
                    } else if (!res.email && res.phone && res.phone_status === 'VERIFIED') {
                        self.needsPhoneVerification = false;
                        self.phoneIsVerified = true;
                    } else if (!res.email && res.phone && res.phone_status !== 'VERIFIED') {
                        self.needsPhoneVerification = true;
                    }

                    self.onVerified({$event: {verified: self.isAutoLogin || self.emailIsVerified || self.phoneIsVerified}});
                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    $scope.$digest();
                });
        };


        self.checkEmailVerificationStatus = function () {
            UserAPI.checkIsVerified('EMAIL')
                .then(function (response) {
                    if (!response.verified) {
                        HNotifications.show({
                            title: $filter("translate")("Your Account has not been verified yet! Check your email and click the link to verify."),
                            desc: '',
                            icon: "fa-times-circle",
                            type: "danger",
                            timeout: 4000
                        });
                    } else {
                        self.onVerified({$event: {verified: response.verified}});
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        };


        self.checkPhoneVerificationStatus = function () {
            UserAPI.checkIsVerified('PHONE')
                .then(function (response) {
                    if (!response.verified) {
                        HNotifications.show({
                            title: $filter("translate")("Your Account has not been verified yet! Check your phone and click the link to verify."),
                            desc: '',
                            icon: "fa-times-circle",
                            type: "danger",
                            timeout: 4000
                        });
                    } else {
                        self.onVerified({$event: {verified: response.verified}});
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        };


        self.sendEmailVerification = function () {

            self.verificationEmailSent = true;
            self.isLoading = true;

            UserAPI.sendVerificationLink('EMAIL')
                .then(function (response) {
                    if (response.status) {
                        HNotifications.show({
                            title: $filter("translate")("An email has been sent to your Email! Please check your inbox"),
                            desc: '',
                            icon: "fa-check",
                            type: "success",
                            timeout: 4000
                        });
                    } else {
                        HNotifications.show({
                            title: $filter("translate")("Something went wrong! Please try again later"),
                            desc: '',
                            icon: "fa-times-circle",
                            type: "danger",
                            timeout: 4000
                        });
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    if (err.status_code === 422) {
                        if (err.data.code === "EMAIL_ALREADY_VERIFIED") {
                            self.onVerified({$event: {verified: true}});
                        }
                    }
                })
                .finally(function () {
                    self.isLoading = false;
                    $scope.$digest();
                });
        };


        self.sendCodeVerification = function () {

            self.verificationPhoneSent = true;
            self.isLoading = true;

            UserAPI.sendVerificationLink('PHONE')
                .then(function (response) {
                    setTimeout(function () {
                        self.isLoading = false;
                        HNotifications.show({
                            title: $filter("translate")("The code has been sent to your Phone via SMS! Please check your phone"),
                            desc: '',
                            icon: "fa-check",
                            type: "success",
                            timeout: 4000
                        });
                    }, 2000);
                })
                .catch(function (err) {
                    console.error(err);
                    HNotifications.show({
                        title: $filter("translate")("Something went wrong! Please try again later"),
                        desc: '',
                        icon: "fa-times-circle",
                        type: "danger",
                        timeout: 4000
                    });
                });
        };

        self.openVerificationModal = function () {
            $modal({
                controller: 'PhoneVerificationByEmployeeModal',
                controllerAs: '$ctrl',
                templateUrl: '../modules/settings/modals/phone-verification-by-employee/phone-verification-by-employee.modal.html',
                show: true,
                resolve: {
                    modalData: function () {
                        return {}
                    },
                    onSave: function () {
                        return function () {
                            self.success = true;
                        };
                    }
                }
            });
        };
    }

})();
